import { BehaviorSubject } from 'rxjs';
// import config from 'config';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider, updatePassword, deleteUser } from "firebase/auth";
import { auth, createCustomerInfo, getUserInfo } from '../_firebase';

import { fetchWrapper, history } from '../_helpers';

const userSubject = new BehaviorSubject(null);
const baseUrl = `${window.location.origin}/accounts`;

export const accountService = {
    login,
    logout,
    register,
    verifyEmail,
    forgotPassword,
    validateResetToken,
    resetPassword,
    loginWithGoogle,
    loginWithFacebook,
    refreshToken,
    deleteLogin,
    userSubject,
    user: userSubject.asObservable(),
    get userValue() { return userSubject.value }
};

function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
}

function logout() {
    // revoke token, stop refresh timer, publish null to user subscribers and redirect to login page
    // fetchWrapper.post(`${baseUrl}/revoke-token`, {});
    return auth.signOut()
        .then(() => {
            userSubject.next(null);
            return Promise.resolve("sign out");
        });

    //stopRefreshTokenTimer();
}

function register(params) {
    //return fetchWrapper.post(`${baseUrl}/register`, params);
    const { email, password, firstName, lastName, mobile } = params;
    const convertedEmail = email.toLowerCase();
    return createUserWithEmailAndPassword(auth, convertedEmail, password)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            window.TRYBOOK.registeredUser = {
                email: convertedEmail,
                firstName: firstName,
                lastName: lastName,
                mobile: mobile,
                mobileVerified: false
            };

            return user;

            // return createCustomerInfo(user.uid, firstName, lastName, mobile, email)
            //     .then(result => user)
            //     .catch((error) => {
            //         const errorMessage = "Registered, but failed to update user info: " + error.message;
            //         return Promise.reject(errorMessage);
            //     });
        })
        .then((user) => {
            return sendEmailVerification(user)
                .catch((error) => {
                    const errorMessage = "Registered, but failed to send email verification: " + error.message;
                    return Promise.reject(errorMessage);
                });
        });
}

function verifyEmail() {
    //return fetchWrapper.post(`${baseUrl}/verify-email`, { token });
    return sendEmailVerification(auth.currentUser);
}

function forgotPassword(email) {
    return sendPasswordResetEmail(auth, email);
}

function loginWithGoogle() {
    if (localStorage.getItem("i18nextLng")?.length === 2) {
        let langCode = localStorage.getItem("i18nextLng");
        auth.languageCode = langCode === 'zh' ? 'zh_cn' : langCode;
    }

    const googleAuthProvider = new GoogleAuthProvider();
    // add mobile number to the scope
    // googleAuthProvider.addScope('https://www.googleapis.com/auth/user.phonenumbers.read');

    return signInWithPopup(auth, googleAuthProvider);
}

function loginWithFacebook() {
    if (localStorage.getItem("i18nextLng")?.length === 2) {
        let langCode = localStorage.getItem("i18nextLng");
        auth.languageCode = langCode === 'zh' ? 'zh_cn' : langCode;
    }

    const fbAuthProvider = new FacebookAuthProvider();

    // add mobile number to the scope
    fbAuthProvider.addScope('user_mobile_phone_number');

    return signInWithPopup(auth, fbAuthProvider);
}

function resetPassword(password) {
    return updatePassword(auth.currentUser, password);
}

function deleteLogin(user) {
    // auth.signOut();
    return deleteUser(user ? user : auth.currentUser);
}

function refreshToken() {

    // return fetchWrapper.post(`${baseUrl}/refresh-token`, {})
    //     .then(user => {
    //         // publish user to subscribers and start timer to refresh token
    //         userSubject.next(user);
    //         startRefreshTokenTimer();
    //         return user;
    //     });

    // return new Promise((resolve, reject) => {
    //     setTimeout( () => resolve( "waiting finish"), 1000);        
    // });

    return Promise.resolve("Obsolete");
}

// ********************* The followning are not used **********************

function validateResetToken(token) {
    return fetchWrapper.post(`${baseUrl}/validate-reset-token`, { token });
}

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

// helper functions

let refreshTokenTimeout;

function startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(userSubject.value.jwtToken.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    refreshTokenTimeout = setTimeout(refreshToken, timeout);
}

function stopRefreshTokenTimer() {
    clearTimeout(refreshTokenTimeout);
}
